import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customerdeal } from '@src/app/models/customerdeal';
import { Project } from '@src/app/models/project';

@Injectable({
  providedIn: 'root'
})
export class CustomerdealService {

  constructor(private http:HttpClient) { }

  //get deals for customer
  getDeals(customerId,pit){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	    /organization/{organizationId}/customer/{customerId}/deal/list/pit/{pitdate}
    return this.http.get<Customerdeal[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/deal/list/pit/'+pit,httpOptions);
 
  }

  //Get specific deal
  getDeal(customerId:string,dealId:string,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	    /organization/{organizationId}/customer/{customerId}/deal/{dealId}/pit/{pitdate}
    return this.http.get<Customerdeal[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/deal/'+dealId+'/pit/'+pit,httpOptions);
 
  }

  //POST	/organization/{organizationId}/customer/{customerId}/deal																				
  createDeal(deal:Customerdeal){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+deal.customerId+'/deal',deal,httpOptions);
  }
  
  //PATCH	/organization/{organizationId}/customer/{customerId}/deal/{dealId}
  updateDeal(deal:Customerdeal){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.patch<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+deal.customerId+'/deal/'+deal.dealId,deal,httpOptions);
 
  }
  //DELETE	/organization/{organizationId}/customer/{customerId}/deal/{dealId} 
  deleteDeal(deal:Customerdeal){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+deal.customerId+'/deal/'+deal.dealId,httpOptions);
 
  } 
  //Get customer projects
  getProjects(customerId,pit){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //GET	    /organization/{organizationId}/customer/{customerId}/project/list/pit/{pitdate}
    return this.http.get<Project[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/project/list/pit/'+pit,httpOptions);
 
  }
}
